<template>
  <div>
    <div class="application11">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <div class="list">
            <div>
              <img src="../../assets/images/application/application11-1.jpg" alt />
              <img src="../../assets/images/application/application11-2.jpg" alt />
            </div>
            <div>
              <img src="../../assets/images/application/application11-3.jpg" alt />
            </div>
          </div>
        </div>
      </module1>
    </div>
    <div class="mobile-application11">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>{{ a.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>{{ b.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 3" :key="index">
              <img :src="getImg(`application11-${index}.jpg`)" alt="Carousel Image" style="width: 100%; height: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application11",
  metaInfo: {
    title:
      "智慧停车可视化管理_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "智慧停车,停车导航,反向寻车,停车预约,停车场可视化地图,车位地图"
      },
      {
        name: "description",
        content:
          "平台实现了包括用户管理、预约管理、订单管理；车位管理、车锁控制、实时定位、轨迹查询、路线导航、停车收费；停车诱导、计时计费、车牌识别、道闸控制等相关功能。为了实现以上系统功能,本系统将基于室内GIS技术、室内定位技术,结合运营商4G、WIFI等无线通信技术,通过与其他软硬件系统之间的集成整合,实现以预约停车导引和反向寻车导航为核心功能的智慧停车应用服务。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧停车可视化管理",
        p:
          "平台实现了包括用户管理、预约管理、订单管理；车位管理、车锁控制、实时定位、轨迹查询、路线导航、停车收费；停车诱导、计时计费、车牌识别、道闸控制等相关功能……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p: "停车场停车预约、停车自动计费、车位可视化查询管理、停车导航引导等。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "平台实现了包括用户管理、预约管理、订单管理；车位管理、车锁控制、实时定位、轨迹查询、路线导航、停车收费；停车诱导、计时计费、车牌识别、道闸控制等相关功能。为了实现以上系统功能，本系统将基于室内GIS技术、室内定位技术，结合运营商4G、WIFI等无线通信技术，通过与其他软硬件系统之间的集成整合，实现以预约停车导引和反向寻车导航为核心功能的智慧停车应用服务。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application11 {
  .list {
    font-size: 0;
    img {
      width: 100%;
    }
    > div {
      display: inline-block;
      width: 584px;
      &:nth-child(1) {
        margin-right: 20px;
        > img:nth-child(1) {
          margin-bottom: 20px;
        }
      }
    }
  }
}
.mobile-application11 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application11 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application11 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application11.vue